module.exports = __webpack_public_path__ + "assets/img/00066.7329f2ca.png";